import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { LayoutDashboard, BarChart3, Eye, CalendarCheck, LogOut } from "lucide-react";

export default function AdminLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const nav = [
    { label: "Leads", testid: "nav-leads", icon: LayoutDashboard, path: "/admin" },
    { label: "Demandes de bilan", testid: "nav-bookings", icon: CalendarCheck, path: "/admin/bookings" },
    { label: "Statistiques", testid: "nav-stats", icon: BarChart3, path: "/admin/stats" },
    { label: "Audience", testid: "nav-audience", icon: Eye, path: "/admin/audience" },
  ];

  return (
    <div className="min-h-screen bg-[#f8f9fc]">
      <header className="bg-[#1a2d56] text-white sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-8">
            <Logo imgClassName="h-7" />
            <nav className="hidden sm:flex items-center gap-1">              {nav.map((n) => {
                const active = location.pathname === n.path;
                return (
                  <button
                    key={n.path}
                    data-testid={n.testid}
                    onClick={() => navigate(n.path)}
                    className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-colors ${
                      active ? "bg-[#d7de3b] text-[#1a2d56]" : "text-white/70 hover:text-white hover:bg-white/10"
                    }`}
                  >
                    <n.icon size={16} /> {n.label}
                  </button>
                );
              })}
            </nav>
          </div>
          <div className="flex items-center gap-4">
            <span className="hidden sm:block text-sm text-white/60">{user?.email}</span>
            <button
              data-testid="logout-button"
              onClick={async () => { await logout(); navigate("/admin/login"); }}
              className="inline-flex items-center gap-2 text-sm font-semibold text-white/80 hover:text-white"
            >
              <LogOut size={16} /> Déconnexion
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-6 py-8">{children}</main>
    </div>
  );
}
